module.exports = __webpack_public_path__ + "static/icons/icon-aviso-adicional.479f37d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon-aviso-adicional.svg
// module id = sLax
// module chunks = 1